import { ModelCategory } from '@paragon/contract-library';

import { GenericModelSchema } from '../ModelSchema';
import { StringProperty } from '../properties';
import { ComponentDesignSchema } from './ComponentDesignSchema';
import { LevelSchema } from './LevelSchema';

export const BuildingSchema = new GenericModelSchema('building', {
  category: ModelCategory.IntermediateModel,
  children: {
    levelInsertions: LevelSchema,
    componentDesignInsertions: ComponentDesignSchema,
  },

  properties: {
    name: StringProperty.configure({ required: true }),
  },
});
